import { IonCol, IonGrid, IonRow, IonText } from "@ionic/react";
import { useEffect, useState } from "react";
import { makeDELETERequest } from "../../request/rawRequest";

interface Props {
  userEmail: string;
}

const deleteAccountReq = async (email: string) => {
  await makeDELETERequest("/user", { email }).then(() => {
    localStorage.clear();
    window.location.reload();
  });
};

const DeleteAccount: React.FC<Props> = ({ userEmail }) => {
  const [value, setValue] = useState<string>("");
  const [firstWarning, setFirstWarning] = useState<boolean>(false);
  const [secondWarning, setSecondWarning] = useState<boolean>(false);

  useEffect(() => {
    if (value.toLowerCase() === "je veux supprimer mon compte") {
      setFirstWarning(true);
    } else {
      setFirstWarning(false);
    }
  }, [value]);

  return (
    <IonRow className="ion-justify-content-center">
      <IonCol
        size="12"
        sizeSm="12"
        sizeLg="8"
        className="ion-justify-content-center"
      >
        <details>
          <summary>
            <IonText className="btn fullWidth ion-justify-content-center flex btn-padding">
              Supprimer son compte
            </IonText>
          </summary>
          <h5 className="black-text no-interaction default-cursor ">
            Veuillez écrire{" "}
            <span className="italic">"je veux supprimer mon compte" </span>
            afin de supprimer toutes les donéees relatives à votre compte. Cette
            action est irréversible et comprend la fin de votre inscription.
          </h5>

          <input
            placeholder="je veux supprimer mon compte"
            className="input margin-5 padding"
            style={{ width: "100%" }}
            onChange={(e) => {
              setValue(e.target.value);
            }}
          ></input>
          {firstWarning && (
            <IonGrid>
              <IonRow>
                <IonCol size="2" sizeLg="2" sizeSm="2">
                  <input
                    id="warnCheck"
                    type="checkbox"
                    value={secondWarning ? "true" : "false"}
                    style={{ width: "100%" }}
                    onChange={(e) => {
                      setSecondWarning(!secondWarning);
                    }}
                  ></input>
                </IonCol>
                <IonCol size="10">
                  <IonText className="black-text">
                    J'accepte et comprend ce que cette action entraine
                  </IonText>
                </IonCol>
                {secondWarning && (
                  <IonText
                    className="margin-5 padding btn fullWidth ion-justify-center flex btn-padding"
                    onClick={() => {
                      deleteAccountReq(userEmail);
                    }}
                  >
                    Supprimer définitivement votre compte
                  </IonText>
                )}
              </IonRow>
            </IonGrid>
          )}
        </details>
      </IonCol>
    </IonRow>
  );
};

export default DeleteAccount;
